import { NotificationCenterConstants } from './notificationCenter.constants'
import { INotificationCenterAction, INotificationCenterState } from './notificationCenter.types'

export const initialNotificationCenterState: INotificationCenterState = {
  items: [],
  readFlagIds: [],
  openedFlagId: null,
  isLoading: false,
  polledNotificationIds: [],
  viewedNotificationIds: [],
}

export function notificationCenterReducer(
  state: INotificationCenterState = initialNotificationCenterState,
  action: INotificationCenterAction
): INotificationCenterState {
  switch (action.type) {
    case NotificationCenterConstants.SET_NOTIFICATIONS:
      return { ...state, items: action.items ?? [] }
    case NotificationCenterConstants.SET_NOTIFICATIONS_LOADING:
      return { ...state, isLoading: action.isLoading ?? false }
    case NotificationCenterConstants.SET_OPENED_FLAG_ID:
      return { ...state, openedFlagId: action.id ?? null }
    case NotificationCenterConstants.SET_READ_FLAG_IDS:
      return { ...state, readFlagIds: action.readFlagIds ?? [] }
    case NotificationCenterConstants.REMOVE_NOTIFICATION:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.id),
      }
    case NotificationCenterConstants.SET_POLLED_NOTIFICATION_IDS:
      return { ...state, polledNotificationIds: action.ids ?? [] }
    case NotificationCenterConstants.SET_VIEWED_NOTIFICATION_IDS:
      return { ...state, viewedNotificationIds: action.ids ?? [] }
    case NotificationCenterConstants.MARK_NOTIFICATIONS_VIEWED:
      return {
        ...state,
        viewedNotificationIds: Array.from(new Set([...state.viewedNotificationIds, ...(action.viewedIds ?? [])])),
      }
    case NotificationCenterConstants.RESET_STATE:
      return initialNotificationCenterState
    default:
      return state
  }
}
